import type { MunicipalityType } from '@/types/municipalityType'
import type { SupplierType } from '@/types/supplierType'
import { RolePermission, type RoleType } from '@/types/roleType'
import type { EntityRelation, Signals } from '@/types/types'

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum sentryUserType {
  MUNICIPALITY = 'municipality',
  SUPPLIER = 'supplier',
}

export const sentryUserTypeTag = 'user_type'

export type UserType = {
  id: string
  email: string
  userStatus: UserStatus
  firstname?: string
  lastname?: string
  profileImage?: string
  municipalities?: Array<MunicipalityType>
  suppliers?: Array<SupplierType>
  organisation?: MunicipalityType['name'] | SupplierType['name']
  permissions: Array<RolePermission>
  roles: Array<RoleType>
  unreadChatMessages: number
  unreadTasks: number
  relations?: EntityRelation[]
  signals?: Signals
}

export type UserTypeFlat = Omit<
  UserType,
  'municipalities' | 'suppliers' | 'permissions' | 'roles'
> & {
  municipalities?: Array<string>
  suppliers?: Array<string>
  roles: Array<string>
}
